import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import styles from '../Messages.module.scss';

const LimitedUseProductsMessage = () => {
  const t = useTranslations();

  return (
    <section
      className={styles.messages}
      data-testid="limited-use-message-container"
    >
      <div className={styles.buyCardMessage}>
        {t('limited_use_description')}
      </div>
      <div className={styles.parallel}>
        <div className={styles.buyCardHeading}>
          {t('select_a_license_caps')}
        </div>
      </div>
    </section>
  );
};

export default LimitedUseProductsMessage;
